<template>
  <div class="h-100 p-0 m-0">
    <div class="col-12 p-0 m-0">
      <div class="card padding-20">
        <div class="d-flex align-items-center justify-content-between mb-4 pb-2 border-bottom">
          <div class="d-flex align-items-center">
            <h5 class="m-0 font-weight-bold">
              {{ isEditing ? 'Խմբագրել օգտատեր' : 'Ավելացնել օգտատեր' }}
            </h5>
          </div>
        </div>

        <form @submit.prevent="submitForm">
          <div class="row">
            <!-- Անուն Ազգանուն -->
            <div class="col-md-6 mb-3">
              <label class="font-weight-medium">Անուն Ազգանուն *</label>
              <input
                type="text"
                class="form-control"
                :class="{'is-invalid': errors.name}"
                v-model="form.name"
                placeholder="Անուն Ազգանուն"
              />
              <div v-if="errors.name" class="invalid-feedback">{{ errors.name }}</div>
            </div>

            <!-- Հեռախոսահամար -->
            <div class="col-md-6 mb-3">
              <label class="font-weight-medium">Հեռախոսահամար *</label>
              <input
                type="text"
                class="form-control"
                :class="{'is-invalid': errors.phone}"
                v-model="form.phone"
                placeholder="+374XXXXXXXX"
              />
              <div v-if="errors.phone" class="invalid-feedback">{{ errors.phone }}</div>
            </div>

            <!-- Էլ. փոստ -->
            <div class="col-md-6 mb-3">
              <label class="font-weight-medium">Էլեկտրոնային փոստ *</label>
              <input
                type="email"
                class="form-control"
                :class="{'is-invalid': errors.email}"
                v-model="form.email"
                placeholder="example@mail.com"
              />
              <div v-if="errors.email" class="invalid-feedback">{{ errors.email }}</div>
            </div>


            <!-- Դերեր -->
            <div class="col-md-6 mb-3">
              <label class="font-weight-medium d-block">Դերեր</label>
              <multiselect
                v-model="selectedRoles"
                :options="availableRoles"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Ընտրեք դերերը"
                label="displayName"
                track-by="id"
                selectLabel=""
                deselectLabel=""
                selectedLabel="Ընտրված է"
              >
                <template v-slot:tag="{ option, remove }">
                  <div class="multiselect__tag">
                    <span>{{ option.displayName || option.name }}</span>
                    <span @click.prevent @mousedown.prevent.stop="remove(option, $event)" class="multiselect__tag-icon">
                      <div class="position-relative w-100 h-100">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.45436 8.32453L8.32616 9.45273L5.00095 6.12752L1.67557 9.45291L0.547363 8.32471L3.87275 4.99932L0.547987 1.67456L1.67619 0.546356L5.00095 3.87112L8.32554 0.546533L9.45374 1.67474L6.12915 4.99932L9.45436 8.32453Z" fill="#595E6B"/>
                        </svg>
                      </div>
                    </span>
                  </div>
                </template>
              </multiselect>
            </div>

            <!-- Ստորաբաժանում -->
            <div class="col-md-6 mb-3">
              <label class="font-weight-medium d-block">Ստորաբաժանում</label>
              <multiselect
                v-model="selectedUnits"
                :options="availableUnits"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Ընտրեք ստորաբաժանումները"
                label="name"
                track-by="id"
                selectLabel=""
                deselectLabel=""
                selectedLabel="Ընտրված է"
              >
                <template v-slot:tag="{ option, remove }">
                  <div class="multiselect__tag">
                    <span>{{ option.name }}</span>
                    <span @click.prevent @mousedown.prevent.stop="remove(option, $event)" class="multiselect__tag-icon">
                      <div class="position-relative w-100 h-100">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.45436 8.32453L8.32616 9.45273L5.00095 6.12752L1.67557 9.45291L0.547363 8.32471L3.87275 4.99932L0.547987 1.67456L1.67619 0.546356L5.00095 3.87112L8.32554 0.546533L9.45374 1.67474L6.12915 4.99932L9.45436 8.32453Z" fill="#595E6B"/>
                        </svg>
                      </div>
                    </span>
                  </div>
                </template>
              </multiselect>
            </div>

            <!-- Կարգավիճակ (Enable/Disable) -->
            <div class="col-md-6 mb-3">
              <label class="font-weight-medium">Կարգավիճակ</label>
              <div class="form-check mt-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="form.is_active"
                  id="is_active_input"
                />
                <label class="form-check-label font-weight-normal" for="is_active_input">
                  {{ form.is_active ? '&#x0531;&#x056F;&#x057F;&#x056B;&#x057E;' : '&#x0531;&#x0576;&#x0561;&#x056F;&#x057F;&#x056B;&#x057E;' }}
                </label>
              </div>
            </div>
          </div>

          <!-- Buttons -->
          <div class="d-flex justify-content-end mt-4 pt-3 border-top">
            <button type="button" class="btn btn-secondary mr-2" @click="goBack">
              Փակել
            </button>
            <button type="submit" class="btn btn-primary px-4" :disabled="submitting">
              <span v-if="submitting" class="spinner-border spinner-border-sm mr-1"></span>
              Պահպանել
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserManagementForm',
  data() {
    return {
      isEditing: false,
      userId: null,
      loadingUser: false,
      submitting: false,
      availableRoles: [],
      selectedRoles: [],
      availableUnits: [],
      selectedUnits: [],
      form: {
        name: '',
        phone: '',
        email: '',
        roles: [],
        units: [],
        is_active: true,
      },
      errors: {},
    }
  },
  async mounted() {
    this.userId = this.$route.params.id || null
    this.isEditing = Boolean(this.userId)
    await Promise.all([this.fetchRoles(), this.fetchUnits()])
    if (this.isEditing) {
      await this.fetchUser()
    }
  },
  methods: {
    goBack() {
      this.$router.push('/user-management')
    },
    async fetchRoles() {
      try {
        const { data } = await this.$client.get('user-management/roles')
        this.availableRoles = (data.data || []).map(r => ({
          ...r,
          displayName: this.$t('roles.' + r.name),
        }))
        if (this.form.roles && this.form.roles.length) {
          this.syncSelectedRoles()
        }
      } catch (e) {
        console.error(e)
      }
    },
    syncSelectedRoles() {
      if (!this.form.roles || !this.form.roles.length) {
        this.selectedRoles = []
        return
      }
      this.selectedRoles = this.form.roles.map(roleName => {
        const found = this.availableRoles.find(r => r.name === roleName)
        return found || { id: roleName, name: roleName, displayName: this.$t('roles.' + roleName) }
      })
    },
    async fetchUnits() {
      try {
        const { data } = await this.$client.get('user-management/units')
        this.availableUnits = data.data || []
        if (this.form.units && this.form.units.length) {
          this.syncSelectedUnits()
        }
      } catch (e) {
        console.error(e)
      }
    },
    syncSelectedUnits() {
      if (!this.form.units || !this.form.units.length) {
        this.selectedUnits = []
        return
      }
      this.selectedUnits = this.form.units.map(unitItem => {
        const unitId = typeof unitItem === 'object' ? unitItem.id : unitItem
        const found = this.availableUnits.find(u => u.id === unitId)
        return found || (typeof unitItem === 'object' ? unitItem : { id: unitId, name: '' })
      })
    },
    async fetchUser() {
      this.loadingUser = true
      try {
        const { data } = await this.$client.get(`user-management/${this.userId}`)
        const user = data.data
        this.form.name = user.name || (user.first_name ? `${user.first_name} ${user.last_name || ''}`.trim() : '')
        this.form.phone = user.phone || ''
        this.form.email = user.email || ''
        this.form.roles = Array.isArray(user.roles) ? [...user.roles] : []
        this.form.units = Array.isArray(user.units) ? [...user.units] : []
        this.form.is_active = user.status === 'ACTIVE'
        this.syncSelectedRoles()
        this.syncSelectedUnits()
      } catch (e) {
        this.$notify({
          group: 'foo',
          type: 'error',
          text: 'Օգտատիրոջ տվյալները բեռնել չհաջողվեց',
        })
        this.goBack()
      } finally {
        this.loadingUser = false
      }
    },
    validate() {
      this.errors = {}
      if (!this.form.name || !this.form.name.trim()) {
        this.errors.name = 'Անուն Ազգանունը պարտադիր է'
      }
      if (!this.form.phone) {
        this.errors.phone = 'Հեռախոսահամարը պարտադիր է'
      }
      if (!this.form.email) {
        this.errors.email = 'Էլ. փոստը պարտադիր է'
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email)) {
        this.errors.email = 'Անվավեր էլ. փոստի ձևաչափ'
      }
      return Object.keys(this.errors).length === 0
    },
    async submitForm() {
      if (!this.validate()) return
      this.submitting = true
      try {
        const payload = {
          ...this.form,
          name: this.form.name.trim(),
          roles: this.selectedRoles.map(r => r.name),
          units: this.selectedUnits.map(u => u.id),
        }
        if (this.isEditing) {
          await this.$client.put(`user-management/${this.userId}`, payload)
          this.$notify({
            group: 'foo',
            type: 'success',
            text: 'Օգտատերը հաջողությամբ թարմացվել է',
          })
        } else {
          await this.$client.post('user-management', payload)
          this.$notify({
            group: 'foo',
            type: 'success',
            text: 'Օգտատերը հաջողությամբ ստեղծվել է',
          })
        }
        this.goBack()
      } catch (e) {
        if (e && e.data && e.data.errors) {
          const serverErrors = e.data.errors
          for (const key in serverErrors) {
            this.$set(this.errors, key, serverErrors[key][0])
          }
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: (e && e.data && e.data.message) || 'Սխալ է տեղի ունեցել',
          })
        }
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>
